var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-skeleton"},[_c('div',{staticClass:"skeleton-grid"},_vm._l((6),function(i){return _c('div',{key:i,staticClass:"skeleton-card"},[_c('div',{staticClass:"skeleton-cover"}),_vm._m(0,true)])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-info"},[_c('div',{staticClass:"skeleton-title"}),_c('div',{staticClass:"skeleton-count"})])
}]

export { render, staticRenderFns }